import { render, staticRenderFns } from "./AddItemDialog.vue?vue&type=template&id=f61ae306&scoped=true&"
import script from "./AddItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddItemDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddItemDialog.vue?vue&type=style&index=0&id=f61ae306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61ae306",
  null
  
)

export default component.exports